import { SortDescriptor } from '@progress/kendo-data-query'
import {
  IbContestInternalResultsKey,
  IbContestInternalResultsSortKey,
} from 'api/Trading-Accounts/Types/MarketingCampaignResultsDto'

export const normalizeIBContestSortQuery = (sortDescriptors: SortDescriptor[]): SortDescriptor[] =>
  sortDescriptors
    .map((x) => {
      if (x.field === IbContestInternalResultsKey.ranking) {
        return { ...x, field: IbContestInternalResultsSortKey.ranking }
      }
      if (x.field === IbContestInternalResultsKey.contestPoints) {
        return { ...x, field: IbContestInternalResultsSortKey.contestPoints }
      }
      if (x.field === IbContestInternalResultsKey.clientsCount) {
        return { ...x, field: IbContestInternalResultsSortKey.clientCount }
      }
      if (x.field === IbContestInternalResultsKey.country) {
        return { ...x, field: IbContestInternalResultsSortKey.country }
      }
      if (x.field === IbContestInternalResultsKey.clientName) {
        return { ...x, field: IbContestInternalResultsSortKey.clientName }
      }

      return x
    })
    .filter((x) => !!x)
